// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Note_wrapper__g_Zyu","text":"Note_text__4tva_","remove":"Note_remove__P_dcI"};